<template>
  <el-container>
    <el-aside width="200px" style="background-color: #FFFFFF">
      <Manage></Manage>
    </el-aside>
    <el-container>
      <el-header style="height:50px;padding: 0">
<!--        <headTop></headTop>-->
      </el-header>
      <el-main style="padding: 0; overflow-y: hidden">
        <createContent></createContent>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import createContent from "@/components/createContent.vue"
import Manage from "@/components/Manage.vue"
import headTop from "@/components/headTop.vue"

export default {
  name: "CreateContentView",
  components: {
    createContent,
    Manage,
    headTop
  },
}
</script>

<style lang="less">
</style>